// The PMO dashboard's framework picker. Each row names the framework it is, or
// is a call-off of (framework_id), so a framework whose own SOW is not on the
// dashboard is still offered for its call-offs.

export function frameworkOptions(rows) {
  const seen = new Map();
  for (const r of rows) {
    if (r.framework_id && !seen.has(r.framework_id)) {
      seen.set(r.framework_id, [r.framework_reference, r.framework_detail].filter(Boolean).join(' · '));
    }
  }
  return [...seen].sort((a, b) => a[1].localeCompare(b[1]));
}

// One framework's rows, with the framework's own row first.
export function scopeToFramework(rows, id) {
  if (!id) return rows;
  const mine = rows.filter(r => r.framework_id === id);
  return [...mine.filter(r => r.sow_id === id), ...mine.filter(r => r.sow_id !== id)];
}
